import {Flag} from 'platform/components';
import {Stack} from 'platform/foundation';

import i18n from '../../../../../i18n/i18n';

export interface ChartLegendProps {
  onStockCount: number;
  soldIn30DaysCount: number;
  soldIn90DaysCount: number;
}

export function ChartLegend(props: ChartLegendProps) {
  return (
    <Stack direction={['column', 'row', 'row', 'row']} spacing={4} wrap>
      <Flag
        label={`${i18n.t('entity.charts.labels.onStock')} (${props.onStockCount})`}
        colorScheme="orange"
      />
      <Flag
        label={`${i18n.t('entity.charts.labels.sold30')} (${props.soldIn30DaysCount})`}
        colorScheme="neutral"
      />
      <Flag
        label={`${i18n.t('entity.charts.labels.sold90')} (${props.soldIn90DaysCount})`}
        colorScheme="black"
        isSubtle
      />
    </Stack>
  );
}
